import React from 'react'
import {Spin} from 'antd'

const Loader = ({size, minHeight}) => (
  <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: minHeight ? minHeight : '100vh'}}>
    <Spin size={size ? size : 'large'}/>
  </div>
)

export default Loader
